import React from 'react';

const PetProfileCard = ({ pet, owner, onEdit }) => {
  return (
    <div className="bg-white rounded-xl shadow-sm overflow-hidden">
      <div className="p-6">
        <div className="flex items-start justify-between">
          <div className="flex items-center">
            <img src={pet.photo} alt={pet.name} className="w-16 h-16 rounded-full object-cover mr-4" />
            <div>
              <h3 className="text-xl font-bold text-gray-800">{pet.name}</h3>
              <p className="text-gray-600">{pet.breed}, {pet.age} años</p>
            </div>
          </div>
          <button 
            onClick={onEdit}
            className="text-cyan-600 hover:text-cyan-800"
          >
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
            </svg>
          </button>
        </div>

        <div className="mt-6 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <h4 className="text-sm font-medium text-gray-500">Información Básica</h4>
            <div className="mt-2 space-y-1">
              <p><span className="font-medium">Especie:</span> {pet.species}</p>
              <p><span className="font-medium">Género:</span> {pet.gender}</p>
              <p><span className="font-medium">Peso:</span> {pet.weight} kg</p>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-gray-500">Salud</h4>
            <div className="mt-2 space-y-1">
              <p><span className="font-medium">Condiciones:</span> {pet.medicalConditions || 'Ninguna'}</p>
              <p><span className="font-medium">Alergias:</span> {pet.allergies || 'Ninguna'}</p>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium text-gray-500">Personalidad</h4>
            <p className="mt-2">{pet.personality}</p>
          </div>

          <div>
            <h4 className="text-sm font-medium text-gray-500">Cuidados Especiales</h4>
            <p className="mt-2">{pet.specialCare || 'Ninguno'}</p>
          </div>
        </div>

        <div className="mt-6">
          <h4 className="text-sm font-medium text-gray-500">Dueño</h4>
          <div className="mt-2">
            <p className="font-medium">{owner.name}</p>
            <p>{owner.phone}</p>
            <p>{owner.email}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PetProfileCard;